import { useIntl } from 'react-intl';
import classNames from 'clsx';

import { CurrencyInput } from 'ui-components/components/currency-input';
import { FlexRow } from 'ui-components/components/flex';
import { Tooltip } from 'ui-components/components/tooltip';

import type { Currency } from '../../../../prop-types/currency-types';
import commonStyle from '../common-style.module.less';
import { messages } from '../messages';

type TotalValueDisplayProps = {
  declaredAmount: Currency;
  quantity: number;
  'aria-label'?: string;
};

export const TotalValueDisplay: React.FC<TotalValueDisplayProps> = ({ declaredAmount, quantity, 'aria-label': ariaLabel = '' }) => {
  const intl = useIntl();
  const validValue = !!(declaredAmount && declaredAmount.value);
  const qty = quantity || 0;

  const calculatedValue = validValue ? Number(declaredAmount.value * qty).toFixed(2) : '';

  return (
    <Tooltip position='top' text={intl.formatMessage(messages.totalValueTooltip)}>
      <div className={commonStyle['standard-input']}>
        <FlexRow>
          <CurrencyInput
            aria-label={ariaLabel}
            className={classNames(commonStyle['currency-input'])}
            currencyCode={declaredAmount.code}
            disabled
            value={calculatedValue}
          />
          <div className={commonStyle['vert-center']}>
            <span className={commonStyle['currency-code']}>{declaredAmount.code}</span>
          </div>
        </FlexRow>
      </div>
    </Tooltip>
  );
};
